export const colors = {
    black: '#000000',
    transparentBlack: 'rgba(0, 0, 0, 0.2)',
    white: '#FFFFFF',
    grey: '#808080',
    greyLight: '#EAEBEB',
    greyBackground: '#EEEEEE',
    greyDark: '#BBBBBB',
    greenLight: '#DCEFB7',
    greenDark: '#20494D',
    blue: '#97c1d0',
    yellow: '#FFD06C',
    orange: '#E85522',
    primary: '#EF8200',
    secondary: '#C6E4E3',
};
